import React, { useState } from 'react';
import BackIcon from 'src/assets/images/BaselineKeyboardArrowLeft.svg';
import BackIconBlue from 'src/assets/images/BaselineKeyboardArrowLeft24.svg';
import ModalDialog from 'src/common/refactoredComponents/modalDialog/modalDialog';
import Close from 'src/assets/images/CloseProduct.svg';
import Spinner from 'src/common/refactoredComponents/spinner/Spinner';
import {
    SearchResultsContainer,
    BackButtonContainer,
    BackButtonIcon,
    BackText,
    SearchHeader,
    DemiText,
    PaginationContainerMobile,
    CloseIconContainer,
    CloseIcon,
    MobileViewPage,
    AccountDetailsContainer,
    MobileView,
    MobileText,
    DesktopText,
    NoDataTextContainer,
    AccountSearchPaginationContainer,
    DesktopView,
    PaginationContainer,
} from './adminSearchResult.styled';
import {
    setAdminSearchOpen,
    clearSearchResult,
    getAdminUserListSearch,
} from 'src/pages/admin/redux/action';
import { isIpad } from 'src/utils/util';
import {
    MessageContainer,
    BoldText,
} from 'src/pages/orders/components/searchOrdersPanel/searchOrdersResult/SearchOrdersResult.styled.jsx';
import BasicPagination from 'src/common/refactoredComponents/paginator';
import { useDispatch, useSelector } from 'react-redux';
import AdminList from 'src/pages/admin/adminList';
import { sizes } from 'src/styles/Media.styled';
import useNonInitialRenderHook from 'src/common/hooks/useNonInitialRenderHook';
import { useTranslation } from 'react-i18next';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
const AdminSearchResult = (props) => {
    const dispatch = useDispatch();
    const [page, setPage] = useState(0);
    const [first, setFirst] = useState(0);
    const iPad = isIpad();

    const onPageChange = (event) => {
        setFirst(event.first);
        setPage(event.page);
    };

    const resetState = () => {
        dispatch(setAdminSearchOpen(false));
        dispatch(clearSearchResult());
    };
    const { t } = useTranslation();
    const discardSearchModal = () => {
        resetState();
    };
    const { loadingSearch } = useSelector((state) => state.AdminReducer);

    // const handleClose = () => {
    //     dispatch(setAdminSearchOpen(false));

    //     props.setSearchParamValues('');
    // };

    const totalSearchRecords = useSelector(
        (state) => state.AdminReducer.totalSearchRecords
    );

    // const displaySearchParams = { ...searchParams };

    // const adminUserList = useSelector(
    //     (state) => state.AdminReducer.adminUserList
    // );

    const searchResults = useSelector(
        (state) => state.AdminReducer.searchResults
    );
    const searachType = useSelector((state) => state.AdminReducer.searachType);

    const searchParams = useSelector(
        (state) => state.AdminReducer.searchParams
    );

    const updateUserStatus = useSelector(
        (state) => state.AdminReducer.updateUserStatus
    );
    const { appliedView, salesOrgFilter } = useSelector((state) => ({
        appliedView: state.AdminReducer.appliedView,
        salesOrgFilter: state.AdminReducer.adminUser?.salesOrgFilter,
    }));

    useEffectWithErrorLogging(() => {
        if (updateUserStatus === '10802') {
            let salesOrgsData = [];
            salesOrgFilter &&
                salesOrgFilter.salesOrgView &&
                salesOrgFilter.salesOrgView.map((item) => {
                    if (
                        item.isChecked ||
                        (!Object.prototype.hasOwnProperty.call(
                            item,
                            'isChecked'
                        ) &&
                            item.isDefault)
                    ) {
                        salesOrgsData.push(item.value);
                    }
                });
            let Param = {
                pageNum: page,
                filteredDistrict:
                    appliedView &&
                    appliedView.appliedDistrict &&
                    appliedView.appliedDistrict.id,
                filteredTerritory:
                    appliedView &&
                    appliedView.appliedTerritory &&
                    appliedView.appliedTerritory.id,
                filteredRole:
                    appliedView &&
                    appliedView.appliedRole &&
                    appliedView.appliedRole.id,
                salesOrgs: salesOrgsData && salesOrgsData.join(','),
            };

            searachType === 'Users'
                ? (Param.networkIdName = searchParams)
                : (Param.accountNameId = searchParams);

            dispatch(getAdminUserListSearch(Param));
        }
    }, [updateUserStatus === '10802']);

    useNonInitialRenderHook(() => {
        // const pageParam = { pageNum: page };
        // const params = { ...pageParam, ...props.searchParamValues };

        let salesOrgsData = [];
        salesOrgFilter &&
            salesOrgFilter.map((item) => {
                if (
                    item.isChecked ||
                    (!Object.prototype.hasOwnProperty.call(item, 'isChecked') &&
                        item.isDefault)
                ) {
                    salesOrgsData.push(item.value);
                }
            });
        let Param = {
            pageNum: page,
            filteredDistrict: appliedView?.appliedDistrict?.id,
            filteredTerritory: appliedView?.appliedTerritory?.id,
            filteredRole: appliedView?.appliedRole?.id,
            salesOrgs: salesOrgsData.join(','),
        };

        searachType === 'Users'
            ? (Param.networkIdName = searchParams)
            : (Param.accountNameId = searchParams);

        dispatch(getAdminUserListSearch(Param));
    }, [page]);

    return (
        <ModalDialog
            modalHeight={'calc(100vh - 120px)'}
            modalWidth={'85%'}
            smalModalWidth={'90%'}
            left={iPad ? '2.5%' : '5%'}
            right={iPad ? '2.5%' : '5%'}
            marginTop={'13.7rem'}
            bottom={'10%'}
            padding={'15px'}
            margin={'0'}
            handleClose={()=>props.handleClose()}
            isAdminPage={true}
        >
            <SearchResultsContainer
                adminSearchOpen={props.adminSearchOpen}
                filterDataOpen={props.filterDataOpen}
            >
                <div className="searchResultsMobile">
                    <SearchHeader>
                        <BackButtonContainer
                            margin={'0'}
                            style={{
                                cursor: 'pointer',
                                alignItems: 'center',
                            }}
                        >
                            <BackButtonIcon
                                id="admin-adminSearchResult-back"
                                margin={'-1px 8px 0 -3px'}
                                marginMob={'0 0 0 -5px'}
                                src={
                                    window.innerWidth > sizes.mobileDevice
                                        ? BackIconBlue
                                        : BackIcon
                                }
                                onClick={props.handleClose}
                            />
                            <BackText
                                id="admin-adminSearchResult-back-text"
                                mbDisplay={'none'}
                                onClick={props.handleClose}
                            >
                                {t('admin.adminHeader.backtoMyCaseUsers')}
                            </BackText>
                        </BackButtonContainer>
                        <DemiText
                            fontSize="20px"
                            color="#140F4B"
                            mbWidth={'100%'}
                        >
                            {t('admin.search.searchResults')} ({searachType})
                        </DemiText>
                        {/* <CloseIconContainer>
                            <CloseIcon
                                mobilePath={Close}
                                show={true}
                                onClick={props.handleClose}
                            />
                        </CloseIconContainer> */}
                    </SearchHeader>
                    {!loadingSearch ? (
                        <MessageContainer
                            className="messageContainerDesktop"
                            mbPadding={'0px 0px 0px 4px'}
                        >
                            {t('admin.search.showing')}
                            <BoldText>
                                {' '}
                                {totalSearchRecords ? totalSearchRecords : '0'}
                            </BoldText>{' '}
                            <DesktopText>
                                {totalSearchRecords?.toString() === '1'
                                    ? `${t(
                                          'calendar.orders.searchResultsPanel.resultLabel'
                                      )} (${searachType})`
                                    : `${t(
                                          'calendar.orders.searchResultsPanel.resultsLabel'
                                      )} (${searachType})`}{' '}
                            </DesktopText>
                            <MobileText>
                                {totalSearchRecords?.toString() === '1'
                                    ? t('admin.search.resultLabel')
                                    : t('admin.search.resultsLabel')}{' '}
                            </MobileText>
                            {t('accounts.accountSearchResult.for')} {'"'}
                            <BoldText>{searchParams}</BoldText>
                            {'"'}
                        </MessageContainer>
                    ) : null}
                </div>
                {loadingSearch ? (
                    <Spinner
                        id="admin-adminSearchResult-search-loadingSpinner"
                        animation="border"
                        variant="primary"
                        small
                        height={'calc(100vh - 190px)'}
                    ></Spinner>
                ) : searchResults?.length > 0 ? (
                    <>
                        <DesktopView>
                            {searchResults?.length > 0 ? (
                                <AccountDetailsContainer className="message-result-wrapper">
                                    <AdminList
                                        searchResults={searchResults}
                                        fromSearch={true}
                                        className="message-result-list-container"
                                        viewFilter={false}
                                    />
                                </AccountDetailsContainer>
                            ) : null}
                        </DesktopView>
                        <MobileView totalResults={props.totalResults}>
                            {searchResults?.length > 0 ? (
                                <AccountDetailsContainer>
                                    <AdminList
                                        searchResults={searchResults}
                                        fromSearch={true}
                                        viewFilter={false}
                                    />
                                </AccountDetailsContainer>
                            ) : null}
                        </MobileView>
                        <DesktopView>
                            <AccountSearchPaginationContainer>
                                <PaginationContainer
                                    style={{
                                        background: '#FFFFFF',
                                    }}
                                >
                                    <BasicPagination
                                        totalRecords={
                                            (totalSearchRecords &&
                                                totalSearchRecords) ||
                                            0
                                        }
                                        recordsFetched={
                                            searchResults &&
                                            searchResults.length
                                        }
                                        pageNumber={page}
                                        handleChange={(e) => onPageChange(e)}
                                        first={first}
                                        // recordsPerPage={pageLimit}
                                        margin="12px 0px"
                                        content={t(
                                            'orders.searchOrdersPanel.ShowingUsers'
                                        )}
                                        iPadPaginatorInfoWidth={'100%'}
                                        iPadPaginatorWidth={'100%'}
                                        // flexDirection={'column'}
                                        // textAlign={'center'}
                                        // iPadPaginatorJustifyContent={'center'}
                                    />
                                </PaginationContainer>
                            </AccountSearchPaginationContainer>
                        </DesktopView>
                        <MobileViewPage>
                            <PaginationContainerMobile padding={'15px'}>
                                <BasicPagination
                                    totalRecords={
                                        (totalSearchRecords &&
                                            totalSearchRecords) ||
                                        0
                                    }
                                    recordsFetched={
                                        searchResults && searchResults.length
                                    }
                                    pageNumber={page}
                                    handleChange={(e) => onPageChange(e)}
                                    first={first}
                                    mobilePadding={'2% 2% 2% 2%'}
                                    content={t(
                                        'orders.searchOrdersPanel.ShowingUsers'
                                    )}
                                />
                            </PaginationContainerMobile>
                        </MobileViewPage>
                    </>
                ) : (
                    <NoDataTextContainer>
                        {t('admin.search.noResultsMessage')}
                    </NoDataTextContainer>
                )}
            </SearchResultsContainer>
        </ModalDialog>
    );
};

export default AdminSearchResult;
